/* eslint-disable consistent-return */
import AsyncStorage from '@react-native-async-storage/async-storage';
// eslint-disable-next-line import/no-extraneous-dependencies
import Constants from 'expo-constants';
import { LinearGradient } from 'expo-linear-gradient';
import React, { useEffect, useState } from 'react';
import { Image, TouchableOpacity, View } from 'react-native';
import { ActivityIndicator } from 'react-native-paper';
import { useDispatch } from 'react-redux';

import conheca_planos from '../../../assets/images/conheca_planos.jpg';
import login_aluno from '../../../assets/images/login_aluno.jpg';
import login_colab from '../../../assets/images/login_colab.jpg';
import login_empresa from '../../../assets/images/login_empresa.jpg';
import login_trainer from '../../../assets/images/login_trainer.jpg';
import logo_purple from '../../../assets/images/logo_purple.png';
import { appColors } from '../../../assets/styles/global';
import { AppText } from '../../../components/form';
import { Logout, pixelDimensions } from '../../../config/utils';
import { getPlanData as getPlanCompany } from '../../../redux/actions/companyActions';
import { getPlanData as getPlanWorker } from '../../../redux/actions/workerActions';
import { CompanyActions } from '../../../redux/reducers/companyReducer';
import { StudentActions } from '../../../redux/reducers/studentReducer';
import { TrainerActions } from '../../../redux/reducers/trainerReducer';
import { WorkerActions } from '../../../redux/reducers/workerReducer';
import { API } from '../../../service/api';
import styles from './styles';

export const ImageButton = ({
  image, text, route, customPadding, colors, navigation, style, innerStyle, imageStyles, fontSize,
}) => (
  <View style={[styles.viewShadow]}>
    <TouchableOpacity
      style={[styles.buttonBig]}
      onPress={() => {
        if (typeof route === 'string') {
          navigation.navigate(route);
        } else {
          route();
        }
      }}
    >
      <LinearGradient style={styles.gradient} colors={colors}>
        <Image source={image} style={[styles.imageBig, imageStyles]} />
        <View style={[{ paddingVertical: customPadding ? pixelDimensions(customPadding) : pixelDimensions(7), paddingHorizontal: pixelDimensions(7) }, innerStyle]}>
          <AppText style={[styles.textBig, { fontSize: fontSize ? pixelDimensions(fontSize) : pixelDimensions(5) }]}>{text}</AppText>
        </View>
      </LinearGradient>
    </TouchableOpacity>
  </View>
);
const apiRouteProfile = {
  EMPRESA: 'empresa',
  PROFISSIONAL: 'profissional',
  COLABORADOR: 'colaborador',
  ALUNO: 'usuario',
};

const LoginBaseWithButtons = ({ navigation }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [userSession, setUserSession] = useState({
    id: '',
    profile: '',
  });
  useEffect(() => {
    AsyncStorage.getItem('PROFILE').then((profile) => AsyncStorage.getItem('ID').then((id) => setUserSession({ id, profile })));
    setLoading(false);
  }, []);

  useEffect(() => {
    const { id, profile } = userSession;
    if (id && profile) {
      if (profile === 'EMPRESA') {
        API.get(`/get/${apiRouteProfile[profile]}/${id}`).then((response) => {
          if (!response.data.data[0]) {
            return Logout(navigation);
          }
          dispatch({ type: CompanyActions.UPDATE_DATA, dataType: 'companyData', dataValue: response.data.data[0] });
          dispatch(getPlanCompany(response.data.data[0].id_plano, navigation));
        }).catch((error) => console.log(error));
      } else if (profile === 'COLABORADOR') {
        API.get(`/get/${apiRouteProfile[profile]}/${id}`).then((response) => {
          if (!response.data.data[0]) {
            return Logout(navigation);
          }
          dispatch({ type: WorkerActions.UPDATE_DATA, dataType: 'workerData', dataValue: response.data.data[0] });
          dispatch(getPlanWorker(response.data.data[0].id_colaborador, navigation));
        }).catch((error) => console.log(error));
      } else if (profile === 'PROFISSIONAL') {
        API.get(`/get/${apiRouteProfile[profile]}/${id}`).then((response) => {
          if (!response.data.data[0]) {
            return Logout(navigation);
          }
          dispatch({ type: TrainerActions.UPDATE_DATA, dataType: 'trainerData', dataValue: response.data.data[0] });
          navigation.navigate('Profile Trainer');
        }).catch((error) => console.log(error));
      } else if (profile === 'ALUNO') {
        API.get(`/get/${apiRouteProfile[profile]}/${id}`).then((response) => {
          if (!response.data.data[0]) {
            return Logout(navigation);
          }
          dispatch({ type: StudentActions.UPDATE_DATA, dataType: 'studentData', dataValue: response.data.data[0] });

          navigation.navigate('Student', { screen: 'Student Profile' });
        }).catch((error) => console.log(error));
      }
    }
  }, [userSession]);

  return (
    <>
      {loading ? (<ActivityIndicator color="#FFF" size={pixelDimensions(7)} />) : (
        <View style={styles.viewBase}>
          <Image style={styles.logo} source={logo_purple} />
          <ImageButton style={{ height: pixelDimensions(20) }} navigation={navigation} fontSize="7" image={login_colab} text="COLABORADOR" colors={['#B496CC', '#0AADED']} route="Login Worker" />
          <ImageButton style={{ height: pixelDimensions(20) }} navigation={navigation} fontSize="7" image={login_empresa} text="EMPRESA" colors={['#B496CC', '#000']} route="Login Company" />
          <View style={styles.viewSeparator} />
          <ImageButton style={{ height: pixelDimensions(20) }} navigation={navigation} fontSize="7" image={login_aluno} text="ALUNO" colors={['#B496CC', '#0A2263']} route="Login Student" />
          <ImageButton style={{ height: pixelDimensions(20) }} customPadding="3" navigation={navigation} fontSize="7" image={login_trainer} text={'PERSONAL\nTRAINER'} colors={['#B496CC', '#0A2263']} route="Login Trainer" />
          <View style={styles.viewSeparator} />
          <View style={{ alignSelf: 'center', marginLeft: pixelDimensions(8) }}>
            <ImageButton style={{ height: pixelDimensions(20) }} innerStyle={{ padding: pixelDimensions(4) }} navigation={navigation} image={conheca_planos} text={'CONHEÇA NOSSOS\nPLANOS'} colors={['#94B771', '#0BB1E1']} route="Planos" />
          </View>
          <AppText style={{ fontFamily: 'MBold', color: appColors.primary, fontSize: pixelDimensions(5) }}>{`v. ${Constants.manifest.version}`}</AppText>
        </View>
      )}
    </>

  );
};

export default LoginBaseWithButtons;
